// Preferences: profile, devices, passkeys, notifications (R10-Q16).
export const me = {
  // The page
  preferences: "Preferences",
  saved: "Saved.",
  signOut: "Sign out",
  thisDevice: "this device",
  off: "Off",
  // How Vantage talks to you
  howVantageTalks: "How Vantage talks to you",
  language: "Language",
  matchMyMessage: "Match my message",
  interfaceLanguage: "Interface language",
  interfaceLanguageHelp: "The app's own words; Vantage answers in the language above.",
  reachBy: "Reach me by",
  reachWeb: "Web",
  reachEmail: "Email",
  reachBoth: "Both",
  reachByHelp: "Where messages passed on to you and your reminders arrive.",
  // Notifications
  notifications: "Notifications",
  notificationsSub: "the bell and badges always update",
  quietHours: "Quiet hours",
  quietHoursHelp: "Pushes and email wait until they end, then come if still unread.",
  quietFrom: "From",
  quietTo: "To",
  quietSameTime: "From and To can't be the same time.",
  quietOvernight: "{start}–{end} (overnight)",
  digestLabel: "Email me unread notifications after",
  digestHelp: "One email (a digest) listing what you haven't read yet.",
  digestHelpOff:
    "One email listing what you haven't read. Email is off for now: the digest starts when an admin turns it on.",
  digestMinutes_one: "{n} minute",
  digestMinutes_other: "{n} minutes",
  digestHours_one: "{n} hour",
  digestHours_other: "{n} hours",
  timeZone: "Time zone",
  timeZoneHelp: "Quiet hours and reminders use it.",
  companyTimeZone: "The company's time zone",
  zoneThisDevice: " · this device",
  // Push notifications
  pushTitle: "Push notifications",
  pushRow: "Get notifications on this device",
  pushIncomplete: "This browser didn't give a complete subscription.",
  pushOnToast: "Notifications are on for this device.",
  pushOnFailed: "Couldn't turn them on.",
  pushOffToast: "Notifications are off for this device.",
  pushOffFailed: "Couldn't turn them off just now.",
  pushChecking: "Checking…",
  pushOnHere:
    "On: mentions, replies, messages passed on to you and finished reports show here, even when Vantage EX is closed.",
  pushOnElsewhere: "On for another of your devices. Turn it on here too?",
  pushOffHere: "Get a notification when you're mentioned, someone replies, or a report is ready.",
  // Your profile
  profileTitle: "Your profile",
  profileSaved: "Profile saved.",
  profileName: "Name",
  profileNameHelp: "What people and Vantage call you; @mentions use it.",
  profileFullName: "Full name",
  profileAbout: "About",
  profileAboutHelp: "{n}/{max} · who you are and what you work on; everyone can read it.",
  profileTitleField: "Title",
  profileTitleHelp: "An admin sets titles: they say who does what.",
  profileSave: "Save profile",
  // Signed-in devices
  devicesTitle: "Signed-in devices",
  devicesWhat: "your devices",
  devicesNone: "No other sign-ins.",
  devicesThisDevice: "This device",
  devicesLastActive: "Last active {when}",
  devicesSignedOutOne: "Signed out there.",
  devicesSignedOutOthers: "Signed out everywhere else.",
  devicesSignOutOthers: "Sign out other devices",
  // Passkeys
  passkeys: "Passkeys",
  passkeysWhat: "your passkeys",
  passkeysHelp: "Sign in with Face ID, Touch ID or your device's lock instead of an email link.",
  passkeysNone: "No passkeys yet.",
  passkeyAdd: "Add a passkey",
  passkeyAdded: "Passkey added.",
  passkeyAddFailed: "Couldn't add a passkey on this device.",
  passkeyExists: "This device already has a passkey here.",
  passkeyUnsupported: "This browser can't make passkeys.",
  passkeyInsecure: "Passkeys work on Vantage EX's secure (https) address, not this one.",
  passkeySignInAgain: "Sign in again",
  passkeyName: "Passkey name",
  passkeyRename: "Rename",
  passkeyRenameFailed: "Couldn't rename it.",
  passkeyRemove: "Remove",
  passkeyRemoveTitle: "Remove this passkey?",
  passkeyRemoveBody: "Remove “{name}”? An email link still signs you in.",
  passkeyRemoveConfirm: "Remove passkey",
  passkeyRemoved: "Passkey removed.",
  passkeyRemoveFailed: "Couldn't remove it.",
  passkeyAddedOn: "Added {date} · {used}",
  passkeyLastUsed: "Last used {date}",
  passkeyNeverUsed: "Never used",
  passkeySignIn: "Sign in with a passkey",
  passkeySignInFailed: "That passkey didn't work. Use the email link instead.",
};
